export const LOGIN_URL = 'auth/login';
export const LOGOUT_URL = 'auth/logout';
export const PHONE_URL = 'auth/phone';
export const REGISTER_URL = 'auth/register';
export const PRE_REG_QUESTIONS_URL = 'auth/preScreenQuestions';
export const USER_URL = 'me';
export const ACTIVATION_URL = 'me/activate';
export const VISIT_URL = 'me/visit';
export const ASSESSMENTS_URL = 'me/survey-data';
export const CLINIC_DATES_URL = 'clinic/availability/dates';
export const CLINIC_TIMES_URL = 'clinic/availability/times';
export const LOOKUP_COUNTRIES = 'lookup/countries';
export const REGISTER = 'auth/register';
export const RESET_PASSWORD = 'admin/resetPassword';
export const GET_LOCATIONS = 'me/getLocations';
export const GET_BLOCKED_DATES_BY_LOCATION =
  'me/listAllBlockedDateAndTimesByLocations';
export const GET_AVAILABLE_TIMES_BY_DATE = 'me/getAvailableSlotsByDate';
export const GET_UPCOMING_APPOINTMENTS = 'me/upComingAppointments';
